import React, { SyntheticEvent } from 'react';

import { Dropdown } from 'semantic-ui-react';

import {
  DropdownContainer,
  IconContainer,
  ImageContainer,
  Image,
  ButtonIcon,
  Divider,
  Title
} from './styles';

import IconButton from '../IconButton';
import { cleanUserSession } from '../../services/auth';

import gruporvSeguros from '../../resources/imgs/gruporv-solution-seguros-grey.svg';
import redevistorias from '../../resources/imgs/redevistorias.svg';
import redeizee from '../../resources/imgs/redeizee.svg';
import painelrv from '../../resources/imgs/gruporv.svg';
import closeIcon from '../../resources/imgs/unify-close.svg';
import signoutIcon from '../../resources/imgs/unify-signout.svg';
import * as Storage from '../../services/storage';

const logoutHandler = (e: SyntheticEvent) => {
  cleanUserSession();
};

const unify = <IconButton name="th" size="big" />;

const UnifiedApps = () => {
  const userToken = Storage.get('id_token');
  const isDevelop =
    process.env.REACT_APP_IS_DEVELOP === 'true' ||
    window.location.hostname === 'app.develop.seguros.redevistorias.com.br' ||
    window.location.hostname === 'localhost';

  const redeOptions = [
    { link: `${process.env.REACT_APP_4SEG_URL}/admin/dashboard`, image: gruporvSeguros },
    {
      link: !isDevelop
        ? `${process.env.REACT_APP_PAINEL_RV_URL}/#access_token=${userToken}&token_type=Bearer&expires_in=86400&scope=users`
        : `${process.env.REACT_APP_PAINEL_RV_DEV_URL}/#access_token=${userToken}&token_type=Bearer&expires_in=86400&scope=users`,
      image: painelrv
    },
    {
      link: !isDevelop
        ? `${process.env.REACT_APP_REDE_VISTORIAS_URL}/#access_token=${userToken}&token_type=Bearer&expires_in=86400`
        : `${process.env.REACT_APP_REDE_VISTORIAS_DEV_URL}/#access_token=${userToken}&token_type=Bearer&expires_in=86400`,
      image: redevistorias
    },
    {
      link: !isDevelop
        ? `${process.env.REACT_APP_REDE_IZEE_URL}/#access_token=${userToken}&token_type=Bearer&expires_in=86400`
        : `${process.env.REACT_APP_REDE_IZEE_DEV_URL}/#access_token=${userToken}&token_type=Bearer&expires_in=86400`,
      image: redeizee
    }
  ];

  return (
    <Dropdown trigger={unify} icon={null} direction="left">
      <Dropdown.Menu>
        <DropdownContainer>
          <IconContainer>
            <ButtonIcon>
              <img src={closeIcon} alt="close" />
            </ButtonIcon>
          </IconContainer>
          <Title>Soluções Grupo RV</Title>
          <Divider />
          <ImageContainer>
            <Dropdown.Item>
              <Image src={redeOptions[0].image} />
            </Dropdown.Item>
            {redeOptions.map((option, index) => {
              if (index !== 0)
                return (
                  <Dropdown.Item>
                    <a href={option.link} target="_blank">
                      <Image src={option.image} />
                    </a>
                  </Dropdown.Item>
                );
            })}
          </ImageContainer>
          <IconContainer>
            <ButtonIcon onClick={logoutHandler}>
              <img src={signoutIcon} alt="sign out" />
            </ButtonIcon>
          </IconContainer>
        </DropdownContainer>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default UnifiedApps;
